import { onError } from '@apollo/client/link/error';
import { RATE_LIMIT_CODES } from './captcha';

type RateLimitHandler = (code: string) => void;

let handler: RateLimitHandler | undefined;

/**
 * Register what should happen when the API refuses a request as rate limited — in
 * practice, showing the global message toast. Registered from `src/app.tsx` rather
 * than imported here: this module is reached through the `src/common` barrel that the
 * message state lives in, so importing it back would close an import cycle.
 */
export function setRateLimitHandler(fn: RateLimitHandler): void {
  handler = fn;
}

/**
 * Surfaces rate-limit denials (`extensions.code` RATE_LIMITED | IP_BLOCKED) to the
 * user. Deliberately NOT `CAPTCHA_REQUIRED`: a challenge is not an error to toast — the
 * submitting form owns it (renders the widget and retries), see
 * `mutations/useCreateSoWithCaptcha.mutate.tsx` and `captcha.ts`.
 */
export const rateLimitErrorLink = onError(({ graphQLErrors }) => {
  if (!graphQLErrors?.length) return;
  const denial = graphQLErrors.find((error) =>
    RATE_LIMIT_CODES.includes(String(error.extensions?.code))
  );
  if (denial) {
    handler?.(String(denial.extensions?.code));
  }
});
